import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/crop-production`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    checkExistence: () => `${RESOURCE_ENDPOINT}/check-existence`,
    getPrevCropProductionData: () => `${RESOURCE_ENDPOINT}/get-prev-crop-production-data`,
    getProductionBlockData: () => `${RESOURCE_ENDPOINT}/get-production-block-data`,
    getLastCultivationProductionData: () => `${RESOURCE_ENDPOINT}/get-last-cultivation-production-data`,
}

export default class CropProductionApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any, params = {}): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url, params);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public checkExistence = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.checkExistence();
        return HttpService.get(url, params, headers);
    }

    public getPrevCropProductionData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPrevCropProductionData();
        return HttpService.get(url, params, headers);
    }

    public getProductionBlockData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getProductionBlockData();
        return HttpService.post(url, payload, params, headers);
    }

    public getLastCultivationProductionData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLastCultivationProductionData();
        return HttpService.post(url, payload, params, headers);
    }
}
